module.exports = __webpack_public_path__ + "img/splash-screen.73ddb014.png";